import { defineStore } from 'pinia';
import { ref } from 'vue';
import influencersAPI from '@/api/influencers';
import { useAlertStore } from '@/store/alertStore';

export const useInfluencersStore = defineStore('influencers', () => {
  const influencers = ref<any[]>([]);
  const influencers_search = ref<any[]>([]);
  const alertStore = useAlertStore();

  const fetchInfluencers = async (params: any): Promise<{ data: any[]; total: number }> => {
    const response = await influencersAPI.getInfluencers(params);
    const data = response.data.data;
    const total = response.data.meta?.total ?? data.length;
    influencers.value = data;
    return { data, total };
  };

  const fetchInfluencerById = async (id: number) => {
    const response = await influencersAPI.getInfluencerById(id);
    return response.data.data;
  };

  const createInfluencer = async (payload: any) => {
    const response = await influencersAPI.createInfluencer(payload);
    if (!response.data.success) throw response.data;
    influencers.value.push(response.data.data);
    alertStore.showAlert('Influencer creado con éxito', 'success');
    return response.data;
  };

  const updateInfluencer = async (id: number, payload: any) => {
    const response = await influencersAPI.updateInfluencer(id, payload);
    if (!response.data.success) throw response.data;
    const updated = response.data.data;
    const idx = influencers.value.findIndex((i: any) => i.id === id);
    if (idx !== -1) influencers.value[idx] = updated;
    alertStore.showAlert('Influencer actualizado con éxito', 'success');
    return response.data;
  };

  const deleteInfluencer = async (id: number) => {
    await influencersAPI.deleteInfluencer(id);
    influencers.value = influencers.value.filter((i: any) => i.id !== id);
    alertStore.showAlert('Influencer eliminado con éxito', 'success');
  };

  const searchInfluencers = async (params: any) => {
    const response = await influencersAPI.getInfluencers(params);
    influencers_search.value = response.data.data;
    return influencers_search.value;
  };

  return {
    influencers,
    influencers_search,
    fetchInfluencers,
    fetchInfluencerById,
    createInfluencer,
    updateInfluencer,
    deleteInfluencer,
    searchInfluencers,
  };
});
